<nav [ngClass]="{ iscomming: sidebarDisplay, isleaving: !sidebarDisplay }">
  <ul>
    @for (buttonList of filteredButtons; track $index) {
      @for (button of buttonList; track $index) {
        <app-sidebar-button [value]="button"> </app-sidebar-button>
      }
      @if ($index !== filteredButtons.length - 1) {
      }
    }
  </ul>

  <div class="theme-toggle-container">
    <app-theme-toggle></app-theme-toggle>
  </div>
</nav>
